module.exports = __webpack_public_path__ + "img/delta.7745461e.png";